import {useState} from 'react';
import {
    Modal,
    ModalContent,
    ModalHeader,
} from '@toppy-webshop/toppy-design-system';
import useEvent from '../../../utils/events/useEvent';
import SupportCaseProvider from '../../utils/SupportCaseProvider';
import Questionaire from './Questionaire';
import ThankYou from './ThankYou';

export interface OpenAfterSalesQuestionaireEvent {
    type: 'openAfterSalesQuestionaire';
}

export interface CloseAfterSalesQuestionaireEvent {
    type: 'closeAfterSalesQuestionaire';
}

interface QuestionaireModalProps {
    bearer: string | null;
    customerName?: string;
}

const QuestionaireModal = ({bearer, customerName}: QuestionaireModalProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEvent<OpenAfterSalesQuestionaireEvent>(
        'openAfterSalesQuestionaire',
        () => setIsModalOpen(true)
    );
    useEvent<CloseAfterSalesQuestionaireEvent>(
        'closeAfterSalesQuestionaire',
        () => setIsModalOpen(false)
    );

    let resetSupportCase: (() => void) | null = null;
    const onClose = () => {
        if (null !== resetSupportCase) resetSupportCase();
        setIsModalOpen(false);
        resetSupportCase = null;
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={onClose}
            bodyOpenClassName={'modal__body--open'}
            ariaHideApp={false}
        >
            <ModalHeader onRequestClose={onClose} />
            <ModalContent>
                {
                    <SupportCaseProvider bearer={isModalOpen ? bearer : null}>
                        {(supportCase, reset) => {
                            resetSupportCase = reset;

                            if (
                                supportCase &&
                                !['draft', 'pending_action'].includes(
                                    supportCase.state
                                )
                            ) {
                                return (
                                    <ThankYou
                                        supportCase={supportCase}
                                        customerName={customerName}
                                    />
                                );
                            }

                            return (
                                <Questionaire
                                    cardsLayout={false}
                                    customerName={customerName}
                                />
                            );
                        }}
                    </SupportCaseProvider>
                }
            </ModalContent>
        </Modal>
    );
};

export default QuestionaireModal;
